import { Navigate } from 'react-router-dom';
import { ROUTES } from '../../../shared/config/routes';
import { useLoginRedirect } from '../hooks/useLoginRedirect';

export function LoginRedirectGate() {
  const { isLoading, isAuthenticated, error } = useLoginRedirect();

  if (isLoading) {
    return null;
  }

  if (error) {
    return null;
  }

  if (isAuthenticated) {
    return <Navigate to={ROUTES.TEMPLATES} replace />;
  }

  return null;
}
